var exports = {
  "I": "x31de4314--6a6e3c--seo-text",
};

module.exports = exports;
